export default {
    optionValueProp: "contractorClientId",
    optionNameProp: "shortName",
    filterProp: ["shortName", "taxNumber"],
}
